import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "semantic-ui-react";

import { gameActions } from "../../store/game-slice";
import { act } from 'react-dom/test-utils';

function GameMenu(props) {
  const dispatch = useDispatch();

  const activeTheme = useSelector((state) => state.game.activeTheme);
  const activeModal = useSelector((state) => state.game.activeModal);

  const [restartOpen, setRestartOpen] = useState(false);

  function btnRestartClickHander() {
    props.onClickStartStopClockHandler(false, false);
    dispatch(gameActions.setGameRestarted(true));
    setRestartOpen(false);
  }

  return (
    <div>
      <ul className="game-menu">
        <li>
          <button type="submit" onClick={props.onChooseThemeClickHander}>
          <img alt="Choose Theme" src={`images/theme-btn${((!props.isInModal && activeTheme === 'theme6') || (props.isInModal && activeModal === 'theme')) ? '-white' : ''}.svg`} className={(activeTheme === 'theme6') ? 'white' : 'purple'} />
          </button>
        </li>
        <li>
          <button type="submit" onClick={props.onHowToPlayClickHander}>
          <img alt="How to Play" src={`images/info-btn${((!props.isInModal && activeTheme === 'theme6') || (props.isInModal && activeModal === 'howtoplay')) ? '-white' : ''}.svg`} className={(activeTheme === 'theme6') ? 'white' : 'purple'} />
          </button>
        </li>
        <li>
          <button type="submit" onClick={props.onBestTimesClickHander}>
          <img alt="Best Times" src={`images/leaderboard-btn${((!props.isInModal && activeTheme === 'theme6') || (props.isInModal && activeModal === 'besttimes')) ? '-white' : ''}.svg`} className={(activeTheme === 'theme6') ? 'white' : 'purple'} />
          </button>
        </li>
        {props.showRestart && (
          <li>
            <button type="submit" onClick={() => {
              setRestartOpen(true);
              }}>
              <img alt="Restart" src={`images/restart-btn${(activeTheme === 'theme6') ? '-white' : ''}.svg`} className={(activeTheme === 'theme6') ? 'white' : 'purple'} />
            </button>
          </li>
        )}
      </ul>
      <Modal
        className="modal-nobg animate flip"
        open={restartOpen}
      >
        <Modal.Content>
        <img src="images/no-take-backs.svg" />

          <button type="submit" onClick={btnRestartClickHander}>
              New Game
          </button>
          <button type="submit" onClick={() => {
            setRestartOpen(false)
            }}>
              Back to Card
          </button>
        </Modal.Content>
      </Modal>
    </div>
  );
}

export default GameMenu;
